import React from "react";
import { Label } from "../../components/ui/label";

const NutritionalValues = ({ updateData, t, capitalizeFirstLetter }) => {
  // Helper function to check if there are any valid nutritional values
  const hasValidNutritionalValues = () => {
    if (!updateData?.nutritionalValues) return false;

    // Check main nutritional values
    const mainValues = Object.entries(updateData.nutritionalValues).some(
      ([key, value]) =>
        key !== "extra_nutritional_values" && key !== "serving" && value !== ""
    );

    // Check extra nutritional values
    const extraValues =
      updateData.nutritionalValues.extra_nutritional_values?.length > 0;

    return mainValues || extraValues;
  };

  if (!hasValidNutritionalValues()) return null;

  return (
    <div className="space-y-2 pt-5">
      <div>
        <Label htmlFor="ingredients" className="text-right">
          {t("menu.nutritional_values")} (
          {capitalizeFirstLetter(updateData?.nutritionalValues?.serving)}) :
        </Label>
      </div>
      <div className="flex flex-wrap gap-5">
        {Object.entries(updateData?.nutritionalValues).map(([key, value]) => {
          if (key !== "extra_nutritional_values" && key !== "serving") {
            if (value === "") return null;
            return (
              <div key={key}>
                <div className="flex flex-col">
                  <div className="font-semibold">{value as string}</div>
                  <Label
                    htmlFor={key}
                    className="text-right text-[#b5b5b5] font-normal"
                  >
                    {capitalizeFirstLetter(key)}
                  </Label>
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
      {updateData?.nutritionalValues.extra_nutritional_values?.length > 0 && (
        <div>
          {updateData.nutritionalValues.extra_nutritional_values.map(
            (item, index) => (
              <div key={index}>
                {Object.entries(item).map(([key, value]) => (
                  <div key={key}>
                    <div className="inline-flex flex-col">
                      <div className="font-semibold">{value as string}</div>
                      <Label
                        htmlFor={key}
                        className="text-right text-[#b5b5b5] font-normal"
                      >
                        {capitalizeFirstLetter(key)}
                      </Label>
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default NutritionalValues;
